var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFittingsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5,5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4145 21.8087C29.6851 23.8331 27.8708 25.405 25.2536 24.0615C22.9273 22.8641 11.6994 16.6282 8.45595 16.0666C5.63056 15.5769 4.85697 18.0005 4.26389 19.6238C3.67082 21.2491 1.13275 31.4022 7.32504 32.4515C13.521 33.4987 19.9012 33.2785 22.5516 33.0522C25.8927 32.7663 27.2115 30.7829 28.1085 28.2462C28.9594 25.835 36.4207 5.09253 36.4207 5.09253",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 24.1666C29.8509 21.7554 36.4205 5.09253 36.4205 5.09253",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFittingsIcon);
export default __webpack_public_path__ + "static/media/fittings-icon.7d2ba137cd6058bbe9394ff920ffe91e.svg";
export { ForwardRef as ReactComponent };